import { Injector, NgModule, inject, provideAppInitializer } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { BROADCAST_CHANNEL_NAME, BroadcastChannelService } from '@shared/v2';
import { CmsPageConnector, SiteContextParamsService, provideConfigFactory } from '@spartacus/core';
import { CmsComponentsService } from '@spartacus/storefront';
import { CustomAuthStatePersistenceModule } from './auth-state-persistence';
import { effects } from './effects';
import { occConfigFactory } from './factory';
import { CustomGlobalMessageModule } from './global-message/custom-global-message.module';
import { InterceptorsModule } from './interceptors/interceptors.module';
import { ResolversModule } from './resolvers/resolvers.module';
import { CustomCmsPageConnector } from './services';
import { CustomCmsComponentsService } from './services/cms-components.service';
import { FeatureFlagService } from './services/feature-flag.service';
import { InstanceUidService } from './services/instance-uid.service';
import { ModalLinkService } from './services/modal-link.service';
import { TokenSyncService } from './services/token-sync.service';

export function instanceUidServiceFactory(injector: Injector): () => void {
  return () => {
    const instanceUidService = injector.get(InstanceUidService);

    instanceUidService.init();
  };
}

export function featureFlagServiceFactory(injector: Injector): () => void {
  return () => {
    const featureFlagService = injector.get(FeatureFlagService);

    featureFlagService.init();
  };
}

export function modalLinkServiceFactory(injector: Injector): () => void {
  return () => {
    const modalLinkService = injector.get(ModalLinkService);

    modalLinkService.init();
  };
}

export function tokenSyncServiceFactory(injector: Injector): () => void {
  return () => {
    injector.get(TokenSyncService);
  };
}

@NgModule({
  imports: [
    ResolversModule,
    CustomGlobalMessageModule,
    InterceptorsModule,
    CustomAuthStatePersistenceModule,
    EffectsModule.forFeature(effects),
  ],
  providers: [
    BroadcastChannelService,
    { provide: BROADCAST_CHANNEL_NAME, useValue: 'sdvor-auth-token-sync' },
    provideConfigFactory(occConfigFactory, [Injector]),
    SiteContextParamsService,
    { provide: CmsPageConnector, useExisting: CustomCmsPageConnector },
    {
      provide: CmsComponentsService,
      useExisting: CustomCmsComponentsService,
    },
    provideAppInitializer(() => {
      const initializerFn = instanceUidServiceFactory(inject(Injector));

      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = featureFlagServiceFactory(inject(Injector));

      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = modalLinkServiceFactory(inject(Injector));

      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = tokenSyncServiceFactory(inject(Injector));

      return initializerFn();
    }),
  ],
})
export class CoreFeatureModule {}
